export default __webpack_public_path__ + "static/media/profile-mia.90b723d7.png";